export default [
  {
    path: 'orders',
    name: 'orders.index',
    meta: {
      title: 'Meus Pedidos',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "orders.index" */ '../views/orders/Index.vue')
  },
  {
    path: 'orders/create',
    name: 'orders.create',
    meta: {
      title: 'Meus Pedidos',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "orders.index" */ '../views/orders/Create.vue')
  },
  {
    path: 'orders/:id',
    name: 'orders.show',
    meta: {
      title: 'Meus Pedidos',
      auth: true,
      RedirectIfAuthenticated: false
    },
    component: () => import(/* webpackChunkName: "orders.show" */ '../views/orders/Show.vue')
  }
]
